import { Layout } from "@/components/layout/Layout";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { COUNTRY_GROUPS, RULESETS, STATUS } from "@/game/rulesets";
import { TESTIDS } from "@/constants/testIds";
import { PlayCircle, BookOpen } from "lucide-react";

export function Variants() {
  const navigate = useNavigate();
  return (
    <Layout>
      <section
        data-testid={TESTIDS.variantsPage}
        className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10"
      >
        <p className="text-xs uppercase tracking-widest text-muted-foreground">Choose your rules</p>
        <h1 className="font-display text-4xl sm:text-5xl mt-1">Variants directory</h1>
        <p className="mt-3 max-w-2xl text-foreground/80">
          A modular registry of Tsoro and its sister games. Each variant runs
          on its own independent rules engine. Only Playable variants are
          guaranteed to follow the listed rules end-to-end.
        </p>

        <div className="mt-10 space-y-10">
          {COUNTRY_GROUPS.map((g) => (
            <div key={g.slug}>
              <h2 className="font-display text-2xl">{g.country}</h2>
              <div className="mt-3 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {g.rulesetIds.map((id) => {
                  const r = RULESETS.find((x) => x.id === id);
                  if (!r) return null;
                  const playable = r.status === STATUS.PLAYABLE;
                  return (
                    <Card key={id} className="p-4" data-testid={TESTIDS.rulesetItem(id)}>
                      <div className="flex items-start justify-between">
                        <p className="font-medium">{r.name}</p>
                        <Badge
                          variant={playable ? "default" : "outline"}
                          className="rounded-full text-[10px] uppercase tracking-widest"
                        >
                          {r.status}
                        </Badge>
                      </div>
                      <p className="text-xs text-muted-foreground mt-1">{r.summary}</p>
                      <p className="text-[10px] uppercase tracking-widest text-muted-foreground mt-3">
                        Board {r.rows}×{r.pitsPerRow} · {r.counters} counters
                      </p>
                      <div className="mt-3 flex gap-2">
                        {playable ? (
                          <Button
                            size="sm"
                            className="rounded-full"
                            data-testid={`play-${id}`}
                            onClick={() => navigate(id === "zimbabwe-standard" ? "/play/standard" : `/play/${id}`)}
                          >
                            <PlayCircle className="h-4 w-4 mr-2" /> Play
                          </Button>
                        ) : (
                          <Button
                            size="sm"
                            variant="outline"
                            className="rounded-full"
                            onClick={() => navigate(`/rules/${g.slug}`)}
                          >
                            <BookOpen className="h-4 w-4 mr-2" /> Rules
                          </Button>
                        )}
                      </div>
                    </Card>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
